import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const IkiFaktorluDogrulamaAktif = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('ikiFaktorluDogrulamaAktif.bannerTitle')}
                path="/nordex-academy"
            />

            <div className="academy-page">
                {/* Giriş */}
                <div className="academy-intro-section py-5">
                    <div className="container">
                        <h3 className="academy-subtitle">{t('ikiFaktorluDogrulamaAktif.subtitle')}</h3>
                        <p className="academy-intro-text">{t('ikiFaktorluDogrulamaAktif.intro.p1')}</p>
                        <p className="academy-intro-text fw-bold">{t('ikiFaktorluDogrulamaAktif.intro.p2')}</p>
                        <ul className="academy-list">
                            {t('ikiFaktorluDogrulamaAktif.intro.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                        <p className="academy-section-text mt-3"><strong>{t('ikiFaktorluDogrulamaAktif.intro.duration')}</strong></p>
                    </div>
                </div>

                {/* Bölüm 1: Hazırlık */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaAktif.section1.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaAktif.section1.intro')}</p>
                        
                        <div className="row g-4">
                            {t('ikiFaktorluDogrulamaAktif.section1.requirements', { returnObjects: true }).map((req, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-type-card">
                                        <h5>{req.title}</h5>
                                        <ul>
                                            {req.items.map((item, iIdx) => (
                                                <li key={iIdx}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="academy-highlight-box  mt-4">
                            <h5>{t('ikiFaktorluDogrulamaAktif.section1.warning.title')}</h5>
                            <p className="mb-0">{t('ikiFaktorluDogrulamaAktif.section1.warning.text')}</p>
                        </div>
                    </div>
                </div>

                {/* Bölüm 2: Uygulama İndirme */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaAktif.section2.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaAktif.section2.intro')}</p>
                        
                        {t('ikiFaktorluDogrulamaAktif.section2.platforms', { returnObjects: true }).map((platform, index) => (
                            <div className="academy-step-card mb-5">
                                <div className="step-content">
                                    <h4>{platform.name}</h4>
                                    <ol>
                                        {platform.steps.map((step, sIdx) => (
                                            <li key={sIdx}>{step}</li>
                                        ))}
                                    </ol>
                                </div>
                            </div>
                        ))}

                        <div className="academy-highlight-box mt-4">
                            <p><strong>{t('ikiFaktorluDogrulamaAktif.section2.alternative.title')}</strong></p>
                            <p className="mb-0">{t('ikiFaktorluDogrulamaAktif.section2.alternative.text')}</p>
                        </div>

                        <div className="academy-type-card mt-4">
                            <h5>{t('ikiFaktorluDogrulamaAktif.section2.firstTime.title')}</h5>
                            <ol>
                                {t('ikiFaktorluDogrulamaAktif.section2.firstTime.steps', { returnObjects: true }).map((step, index) => (
                                    <li key={index}>{step}</li>
                                ))}
                            </ol>
                        </div>
                    </div>
                </div>

                {/* Bölüm 3: Nordex'te 2FA Kurulumu */}
                <div className="academy-section">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaAktif.section3.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaAktif.section3.intro')}</p>
                        
                        {t('ikiFaktorluDogrulamaAktif.section3.steps', { returnObjects: true }).map((step, index) => (
                            <div className="academy-step-card mb-4">
                                <div className="step-content">
                                    <h4>{step.title}</h4>
                                    {step.description && <p>{step.description}</p>}
                                    {step.substeps && (
                                        <ul>
                                            {step.substeps.map((substep, sIdx) => (
                                                <li key={sIdx}>{substep}</li>
                                            ))}
                                        </ul>
                                    )}
                                    {step.note && (
                                        <div className="academy-example-box mt-2">
                                            <small><strong>{t('ikiFaktorluDogrulamaAktif.section3.noteLabel')}</strong> {step.note}</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 4: Yedek Kodlar */}
                <div className="academy-section mb-5 mt-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaAktif.section4.title')}</h2>
                        
                        <div className="academy-highlight-box  text-white">
                            <h5 className="text-white">{t('ikiFaktorluDogrulamaAktif.section4.critical.title')}</h5>
                            <p className="mb-0 fw-bold">{t('ikiFaktorluDogrulamaAktif.section4.critical.text')}</p>
                        </div>

                        <div className="academy-type-card mt-4">
                            <h5>{t('ikiFaktorluDogrulamaAktif.section4.what.title')}</h5>
                            <p>{t('ikiFaktorluDogrulamaAktif.section4.what.description')}</p>
                            
                            <div className="mt-3">
                                <strong>{t('ikiFaktorluDogrulamaAktif.section4.what.usageTitle')}</strong>
                                <ul>
                                    {t('ikiFaktorluDogrulamaAktif.section4.what.usage', { returnObjects: true }).map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="academy-type-card mt-4">
<h5>{t('ikiFaktorluDogrulamaAktif.section4.how.title')}</h5>
                            <ol>
                                {t('ikiFaktorluDogrulamaAktif.section4.how.steps', { returnObjects: true }).map((step, index) => (
                                    <li key={index}>{step}</li>
                                ))}
                            </ol>
                        </div>

                        <div className="academy-highlight-box text-white mt-4">
                            <h6 className="text-white">{t('ikiFaktorluDogrulamaAktif.section4.tip.title')}</h6>
                            <p className="mb-0">{t('ikiFaktorluDogrulamaAktif.section4.tip.text')}</p>
                        </div>
                    </div>
                </div>

                {/* Bölüm 5: 2FA ile Giriş Yapma */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaAktif.section5.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaAktif.section5.intro')}</p>
                        
                        {t('ikiFaktorluDogrulamaAktif.section5.steps', { returnObjects: true }).map((step, index) => (
                            <div className="academy-step-card mb-4">
                                <div className="step-content">
                                    <h4>{step.title}</h4>
                                    <ul>
                                        {step.details.map((detail, dIdx) => (
                                            <li key={dIdx}>{detail}</li>
                                        ))}
                                    </ul>
                                    {step.note && (
                                        <div className="academy-example-box mt-2">
                                            <small>{step.note}</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 6: Sorun Giderme */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaAktif.section6.title')}</h2>
                        <p className="academy-section-text">{t('ikiFaktorluDogrulamaAktif.section6.intro')}</p>
                        
                        {t('ikiFaktorluDogrulamaAktif.section6.problems', { returnObjects: true }).map((problem, index) => (
                            <div className="academy-highlight-box mb-4" key={index}>
                                <h5 className="text-danger">{problem.problem}</h5>
                                <strong className="text-success">{t('ikiFaktorluDogrulamaAktif.section6.solutionLabel')}</strong>
                                <ol className="mt-2 mb-0">
                                    {problem.solutions.map((solution, sIdx) => (
                                        <li key={sIdx}>{solution}</li>
                                    ))}
                                </ol>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Bölüm 7: İpuçları */}
                <div className="academy-section mt-5 mb-5">
                    <div className="container">
                        <h2 className="academy-section-title">{t('ikiFaktorluDogrulamaAktif.section7.title')}</h2>
                        
                        <div className="row g-4">
                            {t('ikiFaktorluDogrulamaAktif.section7.tips', { returnObjects: true }).map((tip, index) => (
                                <div className="col-md-6" key={index}>
                                    <div className="academy-advantage-card">
                                        <h5>{tip.title}</h5>
                                        <p className="mb-0">{tip.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="academy-highlight-box  text-white mt-4">
                            <h5 className="text-white">{t('ikiFaktorluDogrulamaAktif.section7.reminder.title')}</h5>
                            <p className="mb-0 fw-bold">{t('ikiFaktorluDogrulamaAktif.section7.reminder.text')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Cta1 
            title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}/>
        </div>
    );
};

export default IkiFaktorluDogrulamaAktif;
